<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-btn
      icon
      slot="activator"
    >
      <v-icon color="error">delete</v-icon>
    </v-btn>
    <v-card>
      <v-card-title>
        <span class="headline">Veranstaltung löschen</span>
      </v-card-title>
      <v-card-text>
        Möchtest du die Veranstaltung "{{event.title}}" wirklich löschen?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.native="del()" :loading="loading">Löschen</v-btn>
        <v-btn color="primary" @click.native="dialog = false">Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import { VueEditor } from 'vue2-editor';
import { mapActions } from 'vuex';


export default {
  name: 'DlgEventNew',
  components: {
    // VueEditor,
  },
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  props: ['event'],
  methods: {
    ...mapActions({
      eventDel: 'event/del',
      eventRead: 'event/read',
    }),
    del() {
      this.loading = true;
      this.eventDel(this.event).then((res) => {
        this.loading = false;
        if (res) {
          this.eventRead();
          this.dialog = false;
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
